import React, { Component } from 'react'
import { withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import Icon from '../components/misc/Icons'
import {upsertIntegration,} from '../actions/integrations'
import {fetchIntegrationSections} from '../actions/integrations'

var SCOPES = "https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.courses.readonly"


class ImportFromGoogleClassroomButton extends Component {

	constructor(){
		super()
		this.onGoogleLoginSuccess=this.onGoogleLoginSuccess.bind(this)
		this.authenticateWithGoogle=this.authenticateWithGoogle.bind(this)
	}

	authenticateWithGoogle(){
		let params = {
			client_id:process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID,
			scope:SCOPES,
			prompt:'consent',
			responseType:'code',
			accessType:'offline',

		}
		window.gapi.load('auth2', () => {
				const GoogleAuth = window.gapi.auth2.getAuthInstance()	    	
				if(!GoogleAuth){
					window.gapi.auth2.init(params).then(
						res => {
							res.grantOfflineAccess().then(
								res2 => {											
									this.onGoogleLoginSuccess(res2.code)
								})
							})
					}else{		
						GoogleAuth.grantOfflineAccess({scope:SCOPES}).then(
							res =>{
								this.onGoogleLoginSuccess(res.code)
							}				          
						)
					} 
				})
		}

	onGoogleLoginSuccess(authCode){
		this.props.onAuthSuccess()
		//upsert integration
			const requestBody={
			'type':'googleClassroom',
			'authCode':authCode
		}
		this.props.upsertIntegration(requestBody).then((response)=>{
			this.props.fetchIntegrationSections(response.id).then((sections)=>{
				this.props.onLoadGCCourses(sections,response.email,response)				
			})
		})
	}

	render() {
		return (
			<button className='newSection-importGoogleBtn' onClick={this.authenticateWithGoogle}>  
				<div className='newSection-importGoogleBtn-iconContainer'>						
					<Icon name='googleClassroomLogo' />
				</div>
				<div className='newSection-importGoogleBtn-label'>
					Import from Google Classroom...
				</div>				
			</button>
		)
	}
}

export default withRouter(connect(
	(state) => ({

	}),
	{upsertIntegration,fetchIntegrationSections }
)(ImportFromGoogleClassroomButton))